import { BookOutlined } from '@ant-design/icons';
import { withTheme } from '@emotion/react';
import { FC } from 'react';

import { TIconBaseProps } from '../../types/common';

const Book: FC<TIconBaseProps> = ({ theme }) => {
  return (
    <BookOutlined style={{ fontSize: 30, color: theme.COLORS.BLACK._700 }} />
  );
};

export default withTheme(Book);
